/* LOPAZZI — TRACKING COMPLETO */
/* Meta Pixel + GA4 + Clarity + Eventos Shopify */

// ── CONFIG (substitua pelos IDs reais) ──
var LOP_CONFIG = {
  META_PIXEL_ID: 'SEU_PIXEL_ID_AQUI',
  GA4_ID: 'G-XXXXXXXXXX',
  CLARITY_ID: 'SEU_CLARITY_ID'
};

document.addEventListener('DOMContentLoaded', function() {

  // ── MICROSOFT CLARITY ──
  if (LOP_CONFIG.CLARITY_ID !== 'SEU_CLARITY_ID') {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", LOP_CONFIG.CLARITY_ID);
    console.log('[Lopazzi] Clarity carregado');
  }

  // ── META PIXEL ──
  if (LOP_CONFIG.META_PIXEL_ID !== 'SEU_PIXEL_ID_AQUI') {
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', LOP_CONFIG.META_PIXEL_ID);
    fbq('track', 'PageView');
    console.log('[Lopazzi] Meta Pixel carregado');
  }

  // ── GOOGLE ANALYTICS 4 ──
  if (LOP_CONFIG.GA4_ID !== 'G-XXXXXXXXXX') {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + LOP_CONFIG.GA4_ID;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', LOP_CONFIG.GA4_ID, {
      send_page_view: true,
      currency: 'BRL'
    });
    window.gtag = gtag;
    console.log('[Lopazzi] GA4 carregado');
  }

  // ── EVENTOS DE PRODUTO ──
  // View Product
  var productTitle = document.querySelector('.product__title');
  if (productTitle) {
    var productPrice = document.querySelector('.price__sale, .price-item--sale');
    var priceValue = productPrice ? productPrice.textContent.replace(/[^0-9,]/g,'').replace(',','.') : '0';
    // Meta
    if (window.fbq) fbq('track', 'ViewContent', {
      content_name: productTitle.textContent.trim(),
      content_type: 'product',
      currency: 'BRL',
      value: parseFloat(priceValue)
    });
    // GA4
    if (window.gtag) gtag('event', 'view_item', {
      currency: 'BRL',
      value: parseFloat(priceValue),
      items: [{ item_name: productTitle.textContent.trim(), price: parseFloat(priceValue) }]
    });
    // Clarity
    if (window.clarity) clarity('set', 'page_type', 'product');
  }

  // ── EVENTO ADICIONAR AO CARRINHO ──
  document.querySelectorAll('.product-form__submit, [name="add"]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var title = document.querySelector('.product__title');
      var price = document.querySelector('.price__sale, .price-item--sale');
      var pv = price ? price.textContent.replace(/[^0-9,]/g,'').replace(',','.') : '0';
      if (window.fbq) fbq('track', 'AddToCart', {
        content_name: title ? title.textContent.trim() : 'Produto',
        currency: 'BRL',
        value: parseFloat(pv)
      });
      if (window.gtag) gtag('event', 'add_to_cart', {
        currency: 'BRL',
        value: parseFloat(pv),
        items: [{ item_name: title ? title.textContent.trim() : 'Produto', price: parseFloat(pv) }]
      });
    });
  });

  // ── EVENTO BUSCA ──
  var searchForm = document.querySelector('form[action="/search"]');
  if (searchForm) {
    searchForm.addEventListener('submit', function() {
      var q = searchForm.querySelector('input[name="q"]');
      if (window.fbq && q) fbq('track', 'Search', { search_string: q.value });
      if (window.gtag && q) gtag('event', 'search', { search_term: q.value });
    });
  }

  // ── CAPTURA NEWSLETTER (pop-up) ──
  // Quando e-mail é submetido no pop-up, dispara Lead
  var lopPopBtn = document.querySelector('#lop-s1 button');
  if (lopPopBtn) {
    lopPopBtn.addEventListener('click', function() {
      var email = document.getElementById('lop-em');
      if (email && email.value && email.value.includes('@')) {
        if (window.fbq) fbq('track', 'Lead', { content_name: 'popup_email' });
        if (window.gtag) gtag('event', 'generate_lead', { method: 'popup' });
        if (window.clarity) clarity('set', 'lead_type', 'popup_email');
      }
    });
  }

  // ── SCROLL DEPTH TRACKING ──
  var scrollMilestones = [25, 50, 75, 100];
  var fired = {};
  window.addEventListener('scroll', function() {
    var scrolled = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
    scrollMilestones.forEach(function(m) {
      if (scrolled >= m && !fired[m]) {
        fired[m] = true;
        if (window.gtag) gtag('event', 'scroll_depth', { depth: m + '%' });
      }
    });
  }, { passive: true });

  // ── TEMPO NA PÁGINA ──
  var startTime = Date.now();
  window.addEventListener('beforeunload', function() {
    var timeSpent = Math.round((Date.now() - startTime) / 1000);
    if (window.gtag) gtag('event', 'time_on_page', { seconds: timeSpent });
  });

  console.log('[Lopazzi Tracking] Inicializado. Configure os IDs em lopazzi-tracking.js');
});

// ── EVENTO CHECKOUT (via Shopify) ──
if (window.Shopify && window.Shopify.checkout) {
  var checkout = window.Shopify.checkout;
  if (window.fbq) fbq('track', 'Purchase', {
    value: checkout.total_price / 100,
    currency: 'BRL',
    order_id: checkout.order_id
  });
  if (window.gtag) gtag('event', 'purchase', {
    transaction_id: checkout.order_id,
    value: checkout.total_price / 100,
    currency: 'BRL'
  });
}